import {computed, defineComponent, onMounted, reactive} from '@vue/composition-api';
import {
    validateString,
    validateUrl
} from "@/functions/validation-functions";
import {getCountryList} from "@/functions/location-function";
import SelectII from "@/components/select-ii/select-ii.vue";
import axios from "axios";
import {SettingsContext} from "@/utilities/settings-context";
import {alertDialogue, generalError} from "@/functions/system-modal-functions";
import {i18n} from "@/utilities/vue-i18n";
import { validateFullName, validatePhone, validateEmail } from '@noordigitalagency/accounts-ledigajobb';

export default defineComponent({

    components: {

        SelectII
    },

    setup()
    {
        const orgNumberValidationRegex = /^\w+(?:-\w+)?$/iu;

        const settings = reactive({visible: false, countries: [] as Array<{id: string; label: string}>, agreed: false});

        const model = reactive({companyName: '', organizationNumber: '', contactName: '', contactPhone: '', contactEmail: '', homePage: '', city: '', postNumber: '', country: '', address: '', co: '', soleTrader: false});

        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        const shadow = reactive({

            companyName: computed(() => validateString(model.companyName)),

            organizationNumber: computed(() => validateString(model.organizationNumber) && orgNumberValidationRegex.test(model.organizationNumber)),

            contactName: computed(() => validateFullName(model.contactName)),

            contactPhone: computed(() => validatePhone(model.contactPhone)),

            contactEmail: computed(() => validateEmail(model.contactEmail)),

            homePage: computed(() => validateUrl(model.homePage)),

            city: computed(() => validateString(model.city)),

            postNumber: computed(() => validateString(model.postNumber)),

            country: computed(() => validateString(model.country)),

            address: computed(() => validateString(model.address)),

            valid: computed(() => settings.agreed && Object.keys(shadow).filter(key => key !== 'valid' && key !== 'homePage').every(key => shadow[key] === true) && (!model.homePage || shadow.homePage))
        });

        onMounted(async  () => {

            settings.countries = await getCountryList();

            settings.agreed = false;
        });

        const show = () => settings.visible = true;

        const cancel = () => {

            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            Object.keys(model).forEach(key => model[key] = typeof (model[key]) === 'string' ? '' : typeof (model[key]) === 'boolean' ? false : null);

            settings.visible = false;
        }

        const submit = async () => {

            try
            {
                await axios.post(SettingsContext.getApiUrl('connectForeignCompany'), model);

                cancel();

                await alertDialogue(i18n.t('components.company-connection-request.success-title') as string, i18n.t('components.company-connection-request.success-message') as string);
            }
            catch
            {
                await generalError(false);
            }
        };

        return {

            settings,

            show,

            cancel,

            model,

            shadow,

            submit
        };
    }
});
